import { Image } from '@busybusy/webapp-react-ui';
import {
  ToolIcon1,
  ToolIcon10,
  ToolIcon12,
  ToolIcon13,
  ToolIcon14,
  ToolIcon15,
  ToolIcon16,
  ToolIcon17,
  ToolIcon18,
  ToolIcon19,
  ToolIcon2,
  ToolIcon20,
  ToolIcon21,
  ToolIcon22,
  ToolIcon23,
  ToolIcon24,
  ToolIcon25,
  ToolIcon26,
  ToolIcon3,
  ToolIcon4,
  ToolIcon5,
  ToolIcon6,
  ToolIcon7,
  ToolIcon8,
  ToolIcon9,
} from 'assets/equipment-icons/tools';
import './EquipmentIconRenders.scss';

export interface IToolIconsProps {
  onClick: (icon: string) => void;
}

const ToolIcons = (props: IToolIconsProps) => {
  const { onClick } = props;

  const icons = [
    ToolIcon1,
    ToolIcon2,
    ToolIcon3,
    ToolIcon4,
    ToolIcon5,
    ToolIcon6,
    ToolIcon7,
    ToolIcon8,
    ToolIcon9,
    ToolIcon10,
    ToolIcon12,
    ToolIcon13,
    ToolIcon14,
    ToolIcon15,
    ToolIcon16,
    ToolIcon17,
    ToolIcon18,
    ToolIcon19,
    ToolIcon20,
    ToolIcon21,
    ToolIcon22,
    ToolIcon23,
    ToolIcon24,
    ToolIcon25,
    ToolIcon26,
  ];

  return (
    <div className="icon-list mt-2">
      {icons.map((icon, index) => (
        <Image src={icon} key={index} className={'selectable-icon'} onClick={() => onClick(icon)} />
      ))}
    </div>
  );
};

export default ToolIcons;
